import { useSnapshot } from "valtio";
import { enforceTitle } from "./state";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig() ?? {
  publicRuntimeConfig: {
    IS_PROD: false,
    IS_TEST: true,
  },
};
export const EnforceTitle = (props: { children: React.ReactNode }) => {
  const state = useSnapshot(enforceTitle);

  // Only run the check on dev
  if (publicRuntimeConfig.IS_PROD) {
    return <>{props.children}</>;
  }

  return (
    <>
      {props.children}
      {state.title === null ? (
        <div className="bg-overlay fixed inset-0 z-[9999] flex items-center justify-center">
          <div className="flex flex-col items-center justify-center gap-y-5 rounded-md bg-white p-6 text-center shadow-xl">
            <h1 className="font-inter text-3xl font-semibold">
              Set a title using the PageWrapper Component!!
            </h1>
            <img
              src="/v2/set-title.png"
              className="w-[500px] overflow-hidden object-contain"
              alt=""
            />
          </div>
        </div>
      ) : null}
    </>
  );
};
